import { NotFoundPage } from '@/app/pages/NotFoundPage'
import { organizationRouteTree } from '@/app/routes/organizationRoutes'
import { RoutePendingSkeleton } from '@/app/routes/pendingSkeleton'
import {
	globalAccessDeniedRoute,
	indexRoute,
	loginRoute,
	notFoundRoute,
	rootRoute,
	welcomeRoute,
} from '@/app/routes/rootRoutes'
import { ErrorComponent, PathParamError, createRouter } from '@tanstack/react-router'

/**
 * Composition root for the route tree.
 *
 * Each section assembles its own subtree in a sibling module, so this file shows the shape of the URL
 * space rather than every leaf in it: everything tenanted hangs off the organization route, and only
 * the pages that sit above tenancy are listed here.
 */
const routeTree = rootRoute.addChildren([
	loginRoute,
	welcomeRoute,
	globalAccessDeniedRoute,
	organizationRouteTree,
	indexRoute,
	notFoundRoute,
])

export const router = createRouter({
	routeTree,
	defaultNotFoundComponent: () => <NotFoundPage />,
	// A path segment outside its route's schema is an unknown page, not a crash.
	defaultErrorComponent: props =>
		props.error instanceof PathParamError ? <NotFoundPage /> : <ErrorComponent {...props} />,
	defaultPendingComponent: () => <RoutePendingSkeleton />,
})

export type AppRouter = typeof router

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router
	}
}
